import React from 'react';
import { IconProps } from '.';

type RightAngleIconProps = { color?: string } & IconProps;

export const RightAngleIcon: React.FC<RightAngleIconProps> = ({
  width = 9,
  height = 9,
  color = '#222427',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 7 9"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1 1l5 3.532L1 8"
      ></path>
    </svg>
  );
};
